import script from "./voiceDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./voiceDetail.vue?vue&type=script&lang=ts&setup=true"

import "./voiceDetail.vue?vue&type=style&index=0&id=206fd604&lang=scss&scoped=true"
import "./voiceDetail.vue?vue&type=style&index=1&id=206fd604&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206fd604"]])

export default __exports__